<template>
    <div class="wrap">
        <img class="logo" src="../../assets/img/logo.png" alt="">
        <div class="logo-box">
            <div class="title">
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="input-box">
                <div class="input-title">查看成绩</div>
                <!--                <div class="input-line">-->
                <!--                    <div>电话*：</div>-->
                <!--                    <div>-->
                <!--                        <el-input-->
                <!--                                placeholder="请输入内容"-->
                <!--                                v-model="input1"-->
                <!--                                clearable>-->
                <!--                        </el-input>-->
                <!--                        <el-button type="primary">获取验证码</el-button>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="input-line">
                    <div>账号：</div>
                    <div>
                        <el-input
                                placeholder="请输入账号"
                                v-model="identity"
                                clearable>
                        </el-input>
                    </div>
                </div>
                <div class="input-line">
                    <div>密码：</div>
                    <div>
                        <el-input
                                placeholder="请输入密码"
                                v-model="password"
                                clearable>
                        </el-input>
                    </div>
                </div>
                                <div class="input-line">
                                    <div>年级*：</div>
                                    <div>
                                        <el-select v-model="value" placeholder="请选择">
                                            <el-option
                                                    v-for="item in options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="input-line">
                                    <div>姓名*：</div>
                                    <div>
                                        <el-input
                                                placeholder="请输入内容"
                                                v-model="input3"
                                                clearable>
                                        </el-input>
                                    </div>
                                </div>
            </div>
            <div class="chakan">
                <div @click="login">登录</div>
            </div>
        </div>
        <transition name="el-fade-in" mode="out-in">
            <div v-if="popwindow">
                <div class="shade"></div>
                <div class="result-box">
                    <div class="title">
                        <p>查看成绩</p>
                    </div>
                    <p class="grade">答对：88题 答错：2题 用时：5分钟22秒</p>
                    <p class="hint-text">您已掌握本学段单词的0%、 没关系！调整状态，继续努力吧！</p>
                    <div class="hint-box">
                        <div>
                            <div></div>
                            <div>Pass</div>
                        </div>
                        <div>
                            <div></div>
                            <div>Fail</div>
                        </div>
                    </div>
                    <div class="mark-text">
                        <div class="mark-title">
                            单词量测试结果说明
                        </div>
                        <div class="mark-detail">
                            按照教育部考试大纲的要求，根据国家认证中心的单词量测试结果显示，还有43%的单词未掌握，仅掌握了57%，没到教育部考试大纲的要求，需要提高您的词汇量，因为没有单词量，听力听不懂；因为没有单词量，完型不会做；因为没有单词量，阅读不会做；因为没有单词量；翻译译不通；因为没有单词量，写作写不出；更难受的是，再好的老师也教不出没有单词量的学生。闻一知十给你提供听说读写想五位一体快速记忆单词的训练法
                        </div>
                        <div class="mark-btn">
                            <el-button type="primary">查看单词学习指导方案</el-button>
                        </div>
                    </div>
                    <div class="close-btn">
                        <el-button type="danger" @click="popwindow=false">退出测试</el-button>
                    </div>
                </div>
            </div>

        </transition>

    </div>
</template>
<script>
    export default {
        name: 'gradeView',
        data() {
            return {
                identity: '',//账号
                password: '',//密码
                options: [{
                    value: '选项1',
                    label: '小学一年级'
                }, {
                    value: '选项2',
                    label: '小学二年级'
                }, {
                    value: '选项3',
                    label: '小学三年级'
                }, {
                    value: '选项4',
                    label: '小学四年级'
                }, {
                    value: '选项5',
                    label: '小学五年级'
                }],
                value: '',
                popwindow: false,

            }
        },
        methods: {
            // check() {
            //     this.popwindow = true
            // },
            goGuidPage() {

            },
            login() {
                let _this= this
                let params = {
                    emp_no: this.identity = 1,
                    password: this.password = 1001,
                }
                this.$api.Common.login(params).then((res) => {
                    localStorage.setItem('token', res.data.token)
                    this.$message({
                        message: '登录成功',
                        type: 'success',
                        duration:'2000',
                        onClose(){
                            _this.$router.push('/studyIndex')
                        }
                    });
                })

            }
        },
        created() {

        },
    }
</script>
<style lang="less" scoped>
    .wrap {
        height: 100vh;
        position: relative;
        display: flex;
        justify-content: center;
        background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3)), url("../../assets/img/student/login_bg.png");
    }

    .logo {
        position: absolute;
        top: 60px;
        left: 130px;
        width: 300px;
        height: 100px;
    }

    .logo-box {
        height: 700px;
        width: 60vw;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 15px;
        background: #fff;

        .title {
            height: 60px;
            background: #25C6C7;
            display: flex;
            align-items: center;
            padding-left: 10px;
            border-radius: 15px 15px 0px 0px;

            > div {
                height: 22px;
                width: 22px;
                background: #D8EDFE;
                border-radius: 50%;
                margin: 0 5px;
            }

            > div:nth-of-type(2) {
                background: #F8D44F;
            }
        }

        .input-box {
            width: 570px;
            margin: 0 auto;

            .input-title {
                font-size: 24px;
                text-align: center;
                line-height: 100px;
            }

            .input-line {
                display: flex;
                align-items: center;
                margin: 12px 0;

                > div:nth-of-type(1) {
                    width: 130px;
                    font-size: 20px;
                    font-weight: 600;
                }

                > div:nth-of-type(2) {
                    display: flex;
                    flex: 1;
                }

            }
        }

        .chakan {
            display: flex;
            justify-content: center;
            margin-top: 50px;
            cursor: pointer;

            > div {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 167px;
                height: 55px;
                background: rgba(37, 198, 199, 1);
                color: #fff;
                font-size: 20px;
                font-weight: 600;
                transition: all .3s;
            }

            > div:hover {
                background: #2D91C7;
            }
        }

    }

    .pop {
        position: absolute;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        background: rgba(0, 0, 0, 0.6);
    }

    .result-box {
        width: 83vw;
        height: 800px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        border-radius: 15px;
        z-index: 10;

        .title {
            height: 65px;
            background: #25C6C7;
            display: flex;
            align-items: center;
            padding-left: 30px;
            border-radius: 15px 15px 0px 0px;

            p {
                font-size: 18px;
                font-weight: 600;
                color: #fff;
                line-height: 25px;
            }

        }

        .grade {
            text-align: center;
            font-size: 22px;
            margin: 40px 0;
            color: #333333;
            line-height: 29px;
        }

        .hint-text {
            width: 540px;
            height: 82px;
            font-size: 36px;
            color: #416489;
            line-height: 43px;
            margin: 0 auto;
        }

        .hint-box {
            display: flex;
            flex-direction: column;
            align-items: center;

            > div {
                display: flex;
                width: 300px;
                margin: 20px 0;

                > div:nth-of-type(1) {
                    width: 50px;
                    height: 50px;
                    background: #fff;
                    border: 2px solid #00598D;
                    margin-right: 10px;
                }

                > div:nth-of-type(2) {
                    height: 54px;
                    font-size: 54px;
                    font-weight: bold;
                    color: #47C149;
                    line-height: 65px;
                }
            }

            > div:nth-of-type(2) {
                > div:nth-of-type(2) {
                    color: #FF5100;
                }
            }
        }

        .mark-text {

            margin: 0 auto;
            border: 1px solid #E3E3E3;
            padding: 30px 40px;
            font-size: 18px;
            text-align: justify;

            .mark-title {
                border-left: 3px solid #25C6C7;
                padding-left: 10px;
                margin-left: 20px;
                font-size: 16px;
                font-weight: 600;
                color: #333;
            }

            .mark-detail {
                padding-left: 30px;
                line-height: 21px;
                margin-top: 30px;
            }

            .mark-btn {
                padding-top: 20px;
                text-align: right;
            }
        }

        .close-btn {
            padding-top: 20px;
            text-align: center;
        }
    }


    .el-message-box {
        width: 1080px;
        height: 890px;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 30;
        margin: auto;
    }

    .shade {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgb(0, 0, 0);
        opacity: 0.2;
        position: fixed;
        pointer-events: auto;
    }

    .user-box {
        border: none !important;
        overflow-y: auto !important;
        display: flex;
        flex-direction: column;
        padding: 0 115px;

        .info-title {
            display: flex;
            font-size: 22px;

            img {
                width: 30px;
                margin-right: 10px;
            }
        }

        .user-info {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px solid #dcdcdc;
            margin-bottom: 10px;

            .img-box {
                width: 100px;
                height: 100px;
                border-radius: 50%;
                margin-right: 35px;
            }

            .right-info {
                > div {
                    margin: 10px 0;
                }

                .name {
                    font-size: 30px;
                }
            }
        }

        .info-list {
            border-bottom: 1px solid #dcdcdc;

            > div {
                display: flex;
                font-size: 19px;
                margin: 13px 0;
                padding: 0 20px;

                > div:nth-of-type(1) {
                    width: 240px;
                }
            }
        }

        .test-explain {
            border: 1px solid #e3e3e3;
            padding: 15px 10px;
            margin-top: 10px;

            .title {
                color: #2BC3B9;
                border-left: 3px solid #2BC3B9;
                padding-left: 5px;
            }

            p {
                font-size: 16px;
                margin-top: 10px;
            }

            .guid-btn {
                text-align: right;

            }
        }


        .foot-btn {
            margin: 20px 0;
            text-align: center;
        }
    }


</style>